import type { FC, SVGProps } from 'react';

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.8927 10.7153H9.28555V14.1082C9.28555 14.2064 9.36591 14.2867 9.46413 14.2867H10.5356C10.6338 14.2867 10.7141 14.2064 10.7141 14.1082V10.7153H14.107C14.2052 10.7153 14.2856 10.635 14.2856 10.5367V9.46531C14.2856 9.3671 14.2052 9.28674 14.107 9.28674H10.7141V5.89388C10.7141 5.79567 10.6338 5.71531 10.5356 5.71531H9.46413C9.36591 5.71531 9.28555 5.79567 9.28555 5.89388V9.28674H5.8927C5.79448 9.28674 5.71413 9.3671 5.71413 9.46531V10.5367C5.71413 10.635 5.79448 10.7153 5.8927 10.7153Z"
    />
  </svg>
);
